import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { CdxApiGatewayHttpService } from '../../../shared/services/cdx-api-gateway-http.service';
import { Endpoints } from '../../services/endpoints';

export interface JumegaRecord {
  cusip: string;
  originalFace: number;
  currentFace: number;
}

export interface JumegaReportRequest {
  cusipRecords: JumegaRecord[];
}

export interface JumegaReportResponse {
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class JumegaReportService {
  private readonly http = inject(CdxApiGatewayHttpService);

  public generateReport(payload: JumegaReportRequest): Observable<JumegaReportResponse> {
    return this.http.post(Endpoints.JUMEGA_REPORT_ENDPOINT, payload, {
      overrideErrorHandler: true,
    });
  }
}
